import React from 'react';
import { CloseIcon } from './icons/OrganicIcons';

const Modal = ({ isOpen, onClose, children }) => {
  // Cerrar con Escape
  React.useEffect(() => {
    if (!isOpen) return;
    
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // Prevenir scroll del body
  React.useEffect(() => {
    if (!isOpen) return;
    
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div 
        className="absolute inset-0 bg-black/30 backdrop-blur-sm" 
        onClick={onClose}
        role="button"
        tabIndex={-1}
        aria-label="Cerrar modal"
      ></div>
      <div 
        className="relative bg-white/90 backdrop-blur-md rounded-3xl shadow-large border border-white/30 max-w-lg w-full"
        role="document"
      >
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-neutral-500 hover:text-neutral-700 p-2 rounded-full hover:bg-black/5 focus:outline-none focus:ring-2 focus:ring-green-400"
          aria-label="Cerrar"
        >
          <CloseIcon className="w-6 h-6" />
        </button>
        <div className="focus:outline-none" tabIndex={-1}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;